module.exports = __webpack_public_path__ + "img/Visio.575608dd.svg";